module.exports = __webpack_public_path__ + "img/day_cloud.d74bed5e.png";